var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{on:{"close":_vm.closePopup}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.content)}}),_vm._v(" "),(_vm.buttonCancel)?_c('a',{staticClass:"button",on:{"click":_vm.closePopup}},[_vm._v("Cancel")]):_vm._e()])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aec91eb4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/PopupModal.vue
// module id = zRzJ
// module chunks = 1